module.exports = "Enable application of a common theme across all VersionOne UI components, as well as override specific component tree instances with different themes.\r\n"


//////////////////
// WEBPACK FOOTER
// ../src/ThemeProvider/README.md
// module id = 1628
// module chunks = 0